import React from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { UploadTabNames } from "../../agreement/Invoice/components/props";
import { TextInput } from "../../../components/form-group";
import { flattenToDotNotation } from "../../../core/utils/text-utils";
import { PropertyDetails } from "../../../core/api/models/project";
import { Multiselect } from "react-widgets";
import ErrorMessage from "../../../components/text/ErrorMessage";
;

interface CommercialDetail {
    attrName: string;
    attrOptionValue: string | number;
}

interface FormData {
    [key: string]: string | number | { name: string; value: string | undefined }[] | undefined;
}

export interface FormattedData {
    propertyId: string;
    commercialDetails: CommercialDetail[];
}

const EditProposedCommercials: React.FunctionComponent<{
    onSubmit: SubmitHandler<FormattedData>;
    isSaving: boolean;
    commericialDetails: CommercialDetail[];
    properties: PropertyDetails[];
    onClose: () => void;
    firstPropertyDetailsOfGroup: PropertyDetails;
}> = (props) => {
    const {
        control,
        handleSubmit,
        errors
    } = useForm<FormData & { properties?: {name:string, value: string}[]}>({
        reValidateMode: "onChange",
        mode: "onSubmit",
        defaultValues: {
            properties: [{
                value : props.firstPropertyDetailsOfGroup?.propertyId,
                name : `${props.firstPropertyDetailsOfGroup?.propertyName} - ${props.firstPropertyDetailsOfGroup?.floorOffered}`
            }]
        }
    });

    const formatData = (data: FormData, propertyId:string): FormattedData => {
        const formattedData = {
            propertyId,
            commercialDetails: Object.entries(flattenToDotNotation(data)).map(([attrName, attrOptionValue]) => ({
                attrName,
                attrOptionValue : attrOptionValue?.toString?.()
            }))
        };
        return formattedData;
    }
    
    return (
        <form onSubmit={handleSubmit((data) => {

            data?.properties?.forEach(element => {
                const { properties, ...dataWithoutProperties } = data;
                const formattedData = formatData(dataWithoutProperties, element.value);
                props.onSubmit(formattedData);
                
            })

        })}>
            <div className="form-group font-weight-semibold mb-4">
                <label htmlFor="" className="font-sm text-uppercase">
                   Select Properties<span className="text-danger">*</span>
                </label>
                <Controller
                    name="properties"
                    control={control}
                    rules={{  validate: (value) => value && value.length > 0 || "At least one property must be selected" }}
                    render={({ onChange, value }) => (
                        <Multiselect
                            value={value}
                            data={props.properties.map(property => ({
                                name: `${property.propertyName} - ${property.floorOffered}`,
                                value: property.propertyId,
                            }))}
                            textField="name"
                            valueField="value"
                            placeholder="Select"
                            onChange={(val) => {
                                onChange(val);
                            }}
                        />
                    )}
                />
                {errors.properties && (
                <ErrorMessage>Properties is required</ErrorMessage>
              )}
            </div>

            {props.commericialDetails.map((detail: CommercialDetail) => (
                <div className="form-group font-weight-semibold mb-4">
                    <label htmlFor="" className="font-sm text-uppercase">
                        {detail.attrName}
                    </label>
                    <Controller
                        control={control}
                        name={detail.attrName}
                        defaultValue={detail.attrOptionValue}
                        render={({ onChange, value, name }) => (
                            <TextInput
                                gap="sm"
                                type="text"
                                placeholder={detail.attrName}
                                label=""
                                onChange={onChange}
                                name={name}
                                default={value}
                                className="form-control font-weight-semibold"
                            />
                        )}
                    ></Controller>
                </div>
            ))}
            <div className="d-flex justify-content-end">
                <div >
                    <button
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal  px-4 mr-3"
                        onClick={() => {
                            props.onClose();
                        }}
                        disabled={props.isSaving}
                    >
                        Cancel
                    </button>
                </div>
                <div >
                    <button
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 flex-fill"
                        disabled={props.isSaving}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </form>
    );
};
export default EditProposedCommercials;